var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/app-header.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-bd48647e!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/app-header.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/AppHeader.vue
// module id = 5
// module chunks = 1